import { Search } from 'lucide-react'
import type { EntityContextMenuAction } from '@/components/features/entity-context-menu'
import { detectShortcutOs, formatModShortcut } from '@/lib/keyboard-platform'

export function panelSearchShortcutHint(): string {
  return formatModShortcut(detectShortcutOs(), 'f')
}

export function panelSearchMenuAction(onSearch: () => void): EntityContextMenuAction {
  return {
    label: 'Search',
    icon: Search,
    hint: panelSearchShortcutHint(),
    onSelect: onSearch,
  }
}
